export default __webpack_public_path__ + "static/media/zivot2.7a023c72.svg";